import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/terms")({
	component: TermsOfServicePage,
});

function TermsOfServicePage() {
	return (
		<div className="min-h-screen bg-background">
			{/* Hero Section */}
			<section className="relative border-b bg-gradient-to-br from-background via-muted/5 to-background py-20 md:py-32">
				{/* Subtle grid pattern overlay */}
				<div className="absolute inset-0 bg-[linear-gradient(to_right,hsl(198_15%_85%_/_0.3)_1px,transparent_1px),linear-gradient(to_bottom,hsl(198_15%_85%_/_0.3)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] dark:bg-[linear-gradient(to_right,hsl(198_15%_25%_/_0.3)_1px,transparent_1px),linear-gradient(to_bottom,hsl(198_15%_25%_/_0.3)_1px,transparent_1px)]" />
				<div className="container relative mx-auto px-4 md:px-6">
					<div className="mx-auto max-w-3xl text-center">
						<h1 className="font-bold text-4xl tracking-tight md:text-5xl lg:text-6xl">
							Terms of Service
						</h1>
						<p className="mt-4 text-lg text-muted-foreground md:text-xl">
							Last updated: December 6, 2025
						</p>
					</div>
				</div>
			</section>

			{/* Content Section */}
			<section className="py-16 md:py-24">
				<div className="container mx-auto px-4 md:px-6">
					<article
						aria-labelledby="terms-content"
						className="prose prose-neutral prose-lg dark:prose-invert mx-auto max-w-3xl"
					>
						<section className="space-y-4">
							<h2 className="font-bold text-3xl tracking-tight md:text-4xl">
								Agreement to Terms
							</h2>
							<p className="text-muted-foreground leading-relaxed">
								By accessing our website and using our services, you agree to be
								bound by these Terms of Service and all applicable laws and
								regulations.
							</p>
						</section>

						<section className="mt-12 space-y-4">
							<h2 className="font-bold text-3xl tracking-tight md:text-4xl">
								Services
							</h2>
							<p className="text-muted-foreground leading-relaxed">
								Designs by Maryam provides interior design consultation and
								services. Specific terms for individual projects will be
								outlined in separate service agreements.
							</p>
						</section>

						<section className="mt-12 space-y-4">
							<h2 className="font-bold text-3xl tracking-tight md:text-4xl">
								Intellectual Property
							</h2>
							<p className="text-muted-foreground leading-relaxed">
								All content on this website, including designs, images, and
								text, is the property of Designs by Maryam and is protected by
								intellectual property laws.
							</p>
						</section>

						<section className="mt-12 space-y-4">
							<h2 className="font-bold text-3xl tracking-tight md:text-4xl">
								Contact Us
							</h2>
							<p className="text-muted-foreground leading-relaxed">
								If you have any questions about these Terms, please contact us
								at{" "}
								<a
									className="text-primary hover:text-primary/80 hover:underline"
									href="mailto:hello@designsbymaryam.com"
								>
									hello@designsbymaryam.com
								</a>
							</p>
						</section>
					</article>
				</div>
			</section>
		</div>
	);
}
